import Vue from 'vue'

import GamePlay from './components/GamePlay';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios,axios);

if (document.querySelector('#game_play')) {
    const app = new Vue({
        el: '#game_play',
        render: h => h(GamePlay),
    });
}